export const getEnv = () => process.env.NEXT_PUBLIC_GG_NODE_ENV

export const isProduction = getEnv() === 'production';
export const isDevelopment = !isProduction;

export const getApiURL = () => {
  return process.env.NEXT_PUBLIC_API_URL || "https://api.gameglass.gg/api/1"
}